import { render, staticRenderFns } from "./PercentageOfAttempts.vue?vue&type=template&id=2b809ca0"
import script from "./PercentageOfAttempts.vue?vue&type=script&lang=js"
export * from "./PercentageOfAttempts.vue?vue&type=script&lang=js"
import style0 from "./PercentageOfAttempts.vue?vue&type=style&index=0&id=2b809ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports